import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { type UseMetricChartResult, useMetricChart } from '@/components/charts/generic';
import type { ThresholdRange, TiltDataPoint } from '@/domain/behavior';
import { parseLocale } from '@/utils/localeFormatters';

import { buildTiltSpec } from '../../BehaviorTilt/tiltChartSpec';

interface UseOverviewTiltChartDataParams {
    tiltDataPoints: TiltDataPoint[];
    tiltThreshold: ThresholdRange;
}

/** The dashboard's tilt chart: the tilt page's chart with temperature always on the right. */
export function useOverviewTiltChartData({
    tiltDataPoints,
    tiltThreshold,
}: UseOverviewTiltChartDataParams): UseMetricChartResult<'line'> {
    const { t, i18n } = useTranslation('behaviorModule');
    const spec = useMemo(
        () =>
            buildTiltSpec({
                points: tiltDataPoints,
                threshold: tiltThreshold,
                context: 'temperature',
                t,
                locale: parseLocale(i18n.language),
            }),
        [tiltDataPoints, tiltThreshold, t, i18n.language]
    );
    return useMetricChart(spec);
}
